import { PrintType } from '@/types';
import { isPrintColorColorSpace } from './isPrintColorColorSpace';

export const isDigital = (printType: PrintType) => !isPrintColorColorSpace(printType);
